module.exports = __webpack_public_path__ + "static/media/javea-4.bf1fc2ae.jpg";